export default __webpack_public_path__ + "static/media/olatunji.29481d84.webp";